import classnames from 'classnames';
import Link from 'next/link';
import React from 'react';
import ArrowIcon from './arrow.svg';

import styles from './styles.scss';

interface Props {
  href: string;
  as: string;
  text: string;
  marginTop: boolean;
  className?: string;
  external?: boolean;
}

const LinkButton = ({ href, as, text, marginTop, className, external }: Props): JSX.Element => {

  if (external) {
    return (
      <a
        href={href}
        className={classnames(styles.linkButtonContainer, marginTop ? styles.marginTop : null, className && className)}
      >
        <span>{text}</span>
        <span className={styles.icon}>
          <ArrowIcon />
        </span>
      </a>
    );
  }
  return (
    <Link href={href} as={as}>
      <a
        className={classnames(styles.linkButtonContainer, marginTop ? styles.marginTop : null, className && className)}
      >
        <span>{text}</span>
        <span className={styles.icon}>
          <ArrowIcon />
        </span>
      </a>
    </Link>
  );


};

LinkButton.defaultProps = {
  marginTop: false,
};

export default LinkButton;
